// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ChevronUp = createIcon(
  <path
    clipRule="evenodd"
    d="M17.2327 14.0397C16.8813 14.3912 16.3114 14.3912 15.96 14.0397L11.9999 10.0797L8.03987 14.0397C7.6884 14.3912 7.11855 14.3912 6.76708 14.0397C6.41561 13.6882 6.41561 13.1184 6.76708 12.7669L11.3635 8.17049C11.715 7.81902 12.2848 7.81902 12.6363 8.17049L17.2327 12.7669C17.5842 13.1184 17.5842 13.6882 17.2327 14.0397Z"
    fillRule="evenodd"
  />,
);
